import { useState, useEffect } from 'react'
import PinNumber from './PinNumber'
import Questions from './Questions'
import {
  GETCLIENTFEATUREFLAGS,
  GET_CUSTOMER_INFO_BY_PINCODE,
  GET_USER_PROFILE,
  LIVEAGENT_LEAVE_CALL
} from '../../../utils/GraphQLAPI'

import { useLazyQuery, useMutation } from '@apollo/client'
import { KTCard } from '../../../_metronic/helpers'
import CustomerInfo from '../SharedPages/TPVRecordingList/CustomerDetails/CustomerInfo'
import { GLOBAL_CONSTANTS } from '../../../utils/GlobalConstants'
import { areYouSurePrompt } from '../../../utils/helper'
import { Col, Row } from 'react-bootstrap'
const LiveAgentsCall = () => {
  const [pincode, setPincode] = useState<string | undefined>()
  const [details, setDetails] = useState({
    clientName: '',
  })
  const [index, setIndex] = useState(1)
  const [isverified, setIsVerified] = useState(false)
  const [userData, setUserData] = useState<any>()
  const [customerData, setCustomerData] = useState<any>(null)
  const [canEdit, setCanEdit] = useState<boolean>(false)
  const [dispositionMsg, setDispositionMsg] = useState('')
  const [isFlagged, setIsFlagged] = useState(false)
  // Fetch User Profile Data
  const [getUserProfile] = useLazyQuery(GET_USER_PROFILE, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    variables: {
      getEntityName: true,
    },
    onCompleted: async (userDatas) => {
      window.localStorage.setItem('userId', JSON.stringify(userDatas?.getUserProfile?.id))
      setUserData(userDatas.getUserProfile)
    },
  })
  const [getClientFeatureflags, { data: featureFlags }] = useLazyQuery(GETCLIENTFEATUREFLAGS, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  const [leaveCall] = useMutation(LIVEAGENT_LEAVE_CALL)
  const [getCustomerInfo] = useLazyQuery(GET_CUSTOMER_INFO_BY_PINCODE, {
    onCompleted: (data) => {
      setCustomerData(data?.getCustomerInfoByPin)
      getClientFeatureflags({
        variables: {
          customerId: data?.getCustomerInfoByPin?.id,
        },
      })
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  useEffect(() => {
    getUserProfile()
  }, [])

  const onComplete = () => {
    setCanEdit(false)
    setIsVerified(false)
    setPincode(undefined)
    leaveCall({
      variables: {
        tpvId: customerData?.tpvId,
        isCustomerFlagged: isFlagged ? isFlagged : false,
        disposition: Boolean(dispositionMsg) ? dispositionMsg : null,
      },
    })
  }
  const handleCustomerInfoSubmit = () => {
    setCustomerData(null)
    getCustomerInfo({
      variables: {
        pincode,
      },
    })
  }
  return (
    <>
      <div className='d-flex flex-stack container-fluid mb-5' id='kt_app_toolbar_container'>
        <div className='d-flex flex-column'>
          <span className='fs-3 fw-bold text-gray-900'>Live Agent Call</span>
          <span className='text-gray-500 fw-semibold lh-20px fs-7'>Home - Live Agent Call</span>
        </div>
      </div>

      {isverified ? (
        <>
          <Questions
            index={index}
            setIndex={setIndex}
            setPincode={setPincode}
            pincode={pincode}
            onComplete={onComplete}
            leaveCall={leaveCall}
            dispositionMsg={dispositionMsg}
            setIsVerified={setIsVerified}
            customerName={`${customerData?.firstName} ${customerData?.lastName}`}
            details={details}
            tpvId={customerData?.tpvId}
            cardClassName={'mt-5 p-5'}
            rulesSection={
              <KTCard className={'h-100 mt-5 align-items-center py-3'}>
                <div className='my-4 text-center'>
                  <button
                    className='btn btn-danger me-2'
                    onClick={() => {
                      areYouSurePrompt(
                        'Are you sure?',
                        () => {
                          leaveCall({
                            variables: {
                              tpvId: customerData?.tpvId,
                              tpvStatus: 'Incomplete',
                              disposition: Boolean(dispositionMsg) ? dispositionMsg : null,
                            },
                          }).then(() => {
                            setCanEdit(false)
                            setIsVerified(false)
                            setPincode(undefined)
                          })
                        },
                        () => { },
                        'Yes, leave the call',
                        'No, stay in the call',
                        'This will make the TPV status as Incomplete'
                      )
                    }}
                  >
                    Leave Call
                  </button>
                  <button
                    className='btn btn-danger me-2'
                    onClick={() => {
                      areYouSurePrompt(
                        'Are you sure?',
                        () => {
                          leaveCall({
                            variables: {
                              tpvId: customerData?.tpvId,
                              tpvStatus: 'Failed',
                              disposition: Boolean(dispositionMsg) ? dispositionMsg : null,
                            },
                          }).then(() => {
                            setCanEdit(false)
                            setIsVerified(false)
                            setPincode(undefined)
                          })

                        },
                        () => { },
                        'Yes, fail the TPV',
                        'No, stay in the call',
                        'This will fail the TPV'
                      )
                    }}
                  >
                    Leave call and fail TPV
                  </button>
                </div>
                <Row>
                  <Col>
                    <KTCard className={`${'bg-f5f8fa'} h-100 align-items-center py-3`}>
                      <h4 className='text-center'>Rules</h4>
                      <ul>
                        <li>
                          <h6>Clear Yes or No</h6>
                        </li>
                        <li>
                          <h6>Type in other for all other answers</h6>
                        </li>
                      </ul>
                    </KTCard>
                  </Col>
                  <Col lg={'6'}>
                    <div className='form-check form-check-custom form-check-solid d-inline-block me-3'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        checked={isFlagged}
                        onChange={() => setIsFlagged((prev: boolean) => !prev)}
                        id='flexCheckDefault'
                      />
                      <label className='form-check-label' htmlFor='flexCheckDefault'>
                        Flag Account for Additional QC Review
                      </label>
                    </div>

                    <div className='mt-4'>
                      <label className='fs-5 fs-5 fw-bold mb-2'>Disposition</label>
                      <textarea
                        name='businessDescription'
                        className='form-control form-control-lg form-control-solid resize-none min-w-450px min-h-100px'
                        value={dispositionMsg}
                        placeholder='Enter  disposition'
                        maxLength={2000}
                        onChange={(e) => {
                          setDispositionMsg(e.target.value)
                        }}
                        rows={1}
                      ></textarea>
                    </div>
                  </Col>
                </Row>
              </KTCard>

            }
          />
          {canEdit && (
            <KTCard className='mt-5'>
              <CustomerInfo
                data={customerData}
                handleSubmitted={handleCustomerInfoSubmit}
                ediStatus='INCOMPLETE'
                featureFlags={featureFlags}
                showAudit={false}
                showMapAndDistance={false}
              />
            </KTCard>
          )}
        </>
      ) : (
        <PinNumber
          userName={userData ? `${userData.firstName} ${userData.lastName}` : 'user Name'}
          setIndex={setIndex}
          pincode={pincode}
          setPincode={setPincode}
          setIsVerified={setIsVerified}
          setDetails={setDetails}
          getCustomerInfo={getCustomerInfo}
          setCanEdit={setCanEdit}
        />
      )}
    </>
  )
}

export default LiveAgentsCall
